export default "__VITE_ASSET__BWU1TjoI__"